import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Youjiantou"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M4.33361 2.65947L9.47411 7.99947L4.33411 13.3405C4.24443 13.4336 4.19434 13.5579 4.19434 13.6872C4.19434 13.8165 4.24443 13.9408 4.33411 14.034L4.90261 14.6255C4.94814 14.6728 5.00255 14.7107 5.06272 14.7369C5.1229 14.7632 5.18766 14.7774 5.25331 14.7786C5.31896 14.7799 5.38422 14.7682 5.44535 14.7442C5.50649 14.7203 5.5623 14.6845 5.60961 14.639L11.6666 8.34647C11.7563 8.25331 11.8064 8.12902 11.8064 7.99972C11.8064 7.87041 11.7563 7.74613 11.6666 7.65297L10.7371 6.68697L5.62311 1.37447C5.53866 1.28679 5.42513 1.23293 5.30381 1.22298C5.18248 1.21304 5.0617 1.2477 4.96411 1.32047L4.90911 1.36747L4.33411 1.96597C4.24443 2.05913 4.19434 2.18341 4.19434 2.31272C4.19434 2.44203 4.24443 2.56631 4.33411 2.65947H4.33361Z",
  fill: "#737E99"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var youjiantou = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { youjiantou as default };
